// extracted by mini-css-extract-plugin
module.exports = {"link":"_cdaa91f","linkIcon":"_ffc8e5e","logoImg":"_9c451e5"};